import React from 'react';

export default function Modal({ id, title, children, onClose, actions }) {
  return (
    <div className="modal-overlay active">
      <div className="modal">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h3 style={{ margin: 0 }}>{title}</h3>
          <button
            onClick={onClose}
            style={{ background: 'none', border: 'none', color: 'var(--gray)', fontSize: 20, cursor: 'pointer' }}
          >✕</button>
        </div>
        {children}
        {actions && (
          <div className="modal-actions">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}
